import React from 'react';
import PropTypes from 'prop-types';
import './FormSelect.scss';

const FormSelect = (props) => {
  const { id, label, input, children, required, autoTestClass, meta: { touched, error } } = props;
  const errorClass = touched && error ? 'form-select-error ' : '';
  return (
    <div className="form-select-container form-group">
      <div>
        <label htmlFor={id}>{label}</label>
        {required &&
        <span className="form-required-text">*</span>
        }
      </div>
      <select
        className={`${errorClass}form-select form-control ${autoTestClass}`}
        id={id} {...input}
      >
        {children}
      </select>
      {errorClass &&
      <div className="form-select-validation-error">{error}</div>
      }
    </div>
  );
};

FormSelect.propTypes = {
  id: PropTypes.string,
  label: PropTypes.string,
  autoTestClass: PropTypes.string,
  input: PropTypes.object,
  children: PropTypes.arrayOf(PropTypes.object),
  meta: PropTypes.object,
  required: PropTypes.bool
};

export default FormSelect;



/** WEBPACK FOOTER **
 ** ./src/components/form/FormSelect/FormSelect.js
 **/